import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import ButtonBasic from 'components/common/ButtonBasic'
import { InfoModal } from 'components/common/Modal'

const LoginRequiredModal = ({ open, onClose, onLogin }) => (
  <InfoModal open={open} onClose={onClose}>
    <Typography variant="titleLarge" p={5}>
      請先登入會員方可查看內容及使用會員服務
    </Typography>
    <Box display="flex" justifyContent="flex-end" gap={2.5} p={5}>
      <ButtonBasic
        variant="outlined"
        onClick={onClose}
        size="medium"
        color="neutral"
      >
        取消
      </ButtonBasic>
      <ButtonBasic
        variant="contained"
        onClick={onLogin}
        size="medium"
        id="login"
      >
        登入
      </ButtonBasic>
    </Box>
  </InfoModal>
)

export default LoginRequiredModal
